import React from 'react';

const StatCard = ({ icon: Icon, label, value, trend, trendUp, iconColor, bgColor, ...rest }) => {
  const testId = rest['data-testid'] || `stat-card-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div
      className="bg-white rounded-xl p-3 sm:p-4 lg:p-6 border border-slate-200 hover:shadow-lg transition-shadow duration-200"
      data-testid={testId}
    >
      <div className="flex items-start gap-2 sm:gap-3 lg:gap-4">
        <div className={`p-2 sm:p-2.5 lg:p-3 ${bgColor} rounded-lg flex-shrink-0`}>
          <Icon className={`w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 ${iconColor}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs text-slate-600 mb-0.5 sm:mb-1 uppercase tracking-wider truncate">
            {label}
          </p>
          <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-slate-900 mb-0.5 sm:mb-1 break-words">
            {value}
          </p>
          {trend && (
            <p
              className={`text-[11px] sm:text-xs lg:text-sm leading-snug ${
                trendUp ? 'text-emerald-600' : 'text-slate-500'
              }`}
            >
              {trend}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
